module.exports = __webpack_public_path__ + "static/media/jean-paul-gaultier-le-male-big.89dc0809.png";